/**
 * @template T
 * @param {T[]} items
 * @param {{(item: T, index: number): void}} callback
 * @returns {T[]}
 */
export function forEach(items, callback) {
  if (items) {
    const length = items.length
    for (let i = 0; i < length; ++i) {
      callback(items[i], i)
    }
  }
  return items
}

export function hasCssClass(element, name) {
  const classList = element && element.classList
  return (classList && classList.contains(name)) || false
}

export function setCssClass(element, name, value) {
  const classList = element && element.classList
  if (classList) {
    if (value) {
      classList.add(name)
    } else {
      classList.remove(name)
    }
  }
}

const trimRegex = /^\s+|\s+$/g

export function trimString(value) {
  return value === null || value === undefined ? '' : ('' + value).replace(trimRegex, '')
}

export function cancelEvent(event) {
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault()
  }
  return false
}
